import React from "react";
import PropTypes from "prop-types";

import SocialSelector from "./SocialSelector";

import { capitalize } from "utils/capitalize";

import { Box, TextField } from "@mui/material";

const Content = ({ pageElementId, elementType, content, onChange }) => {

  return (
    <Box sx={{ p: 2, display: "grid", gridTemplateColumns: "150px 1fr", gap: 2 }}>
      <SocialSelector
        elementType={elementType}
        disabled={!!pageElementId}
        onChange={onChange}
      />

      <TextField
        size="small"
        name="content"
        label={elementType ? capitalize(elementType) : "Link"}
        value={content}
        onChange={onChange}
        fullWidth
        color="warning"
      />
    </Box>
  );
};

Content.propTypes = {
  pageElementId: PropTypes.number,
  elementType: PropTypes.string,
  content: PropTypes.string,
  onChange: PropTypes.func,
};

export default Content;
